/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Cloud API Specification
 * OpenAPI spec version: 0.0.7
 */

export type AzureCollectorCreateCreateUpdateRequestService =
  (typeof AzureCollectorCreateCreateUpdateRequestService)[keyof typeof AzureCollectorCreateCreateUpdateRequestService];

export const AzureCollectorCreateCreateUpdateRequestService = {
  BLOB_STORAGE: 'BLOB_STORAGE',
  CACHE_FOR_REDIS: 'CACHE_FOR_REDIS',
  CACHE_FOR_REDIS_ENTERPRISE: 'CACHE_FOR_REDIS_ENTERPRISE',
  COSMOS_DB: 'COSMOS_DB',
  DATABASE_FOR_MYSQL: 'DATABASE_FOR_MYSQL',
  DATABASE_FOR_POSTGRESQL: 'DATABASE_FOR_POSTGRESQL',
  FUNCTIONS: 'FUNCTIONS',
  SQL_DATABASE: 'SQL_DATABASE',
  VIRTUAL_MACHINES: 'VIRTUAL_MACHINES',
} as const;
